export const ASCENSO = 'A';
export const ASCENSO_X_PROMEDIO = 'P';
export const DESCENSO = 'D';
export const DESCENSO_X_PROMEDIO = 'R';
